import { Card, CardContent } from '@/components/ui/card'
import { ArrowRight, Clock, Car } from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

export function OperationShowcase() {
  const { t } = useI18n()

  return (
    <section className="py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter mb-4 leading-tight">
            {t('op.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-medium">
            {t('op.subtitle')}
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto flex justify-center animate-fade-in">
          {/* Mock of list */}
          <div className="w-full md:w-3/4 bg-card rounded-xl border shadow-xl p-4 space-y-3 opacity-50 scale-[0.98] origin-left">
            <div className="flex items-center justify-between p-4 rounded-xl border bg-muted">
              <div className="flex items-center gap-4">
                <Car className="text-muted-foreground" />
                <span className="text-2xl font-extrabold tracking-tight">
                  XYZ-9876
                </span>
              </div>
              <div className="font-bold text-lg text-secondary">R$ 15,00</div>
            </div>
            <div className="flex items-center justify-between p-4 rounded-xl border bg-muted">
              <div className="flex items-center gap-4">
                <Car className="text-muted-foreground" />
                <span className="text-2xl font-extrabold tracking-tight">
                  KJL-0000
                </span>
              </div>
              <div className="font-bold text-lg text-secondary">R$ 25,00</div>
            </div>
            <div className="flex items-center justify-between p-4 rounded-xl border bg-muted">
              <div className="flex items-center gap-4">
                <Car className="text-muted-foreground" />
                <span className="text-2xl font-extrabold tracking-tight">
                  MNO-1111
                </span>
              </div>
              <div className="font-bold text-lg text-secondary">R$ 10,00</div>
            </div>
          </div>

          {/* Drawer overlapping */}
          <Card className="absolute top-4 right-0 md:right-10 w-[350px] shadow-2xl border-primary/20 animate-slide-in-from-right z-10 hidden sm:block">
            <div className="bg-primary text-primary-foreground p-6 rounded-t-xl">
              <div className="text-sm opacity-80 font-semibold tracking-wide">
                {t('op.checkout')}
              </div>
              <div className="text-3xl font-extrabold tracking-tighter mt-1">
                ABC-1234
              </div>
              <div className="text-sm mt-1 opacity-90 font-medium">
                {t('op.entryAt')}
              </div>
            </div>
            <CardContent className="p-6 space-y-6 bg-background rounded-b-xl">
              <div className="flex items-center gap-3 border-b pb-4">
                <div className="bg-muted p-3 rounded-full">
                  <Clock className="h-5 w-5 text-muted-foreground" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-muted-foreground">
                    {t('op.duration')}
                  </div>
                  <div className="font-extrabold text-lg tracking-tight">
                    2h 15m
                  </div>
                </div>
              </div>
              <div className="text-center bg-secondary/10 p-4 rounded-xl border border-secondary/20">
                <div className="text-xs uppercase font-extrabold text-muted-foreground tracking-wider">
                  {t('op.amount')}
                </div>
                <div className="text-4xl font-extrabold tracking-tighter text-secondary mt-1">
                  R$ 20,00
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div className="h-12 rounded-md border flex items-center justify-center font-bold text-emerald-600 border-emerald-200 bg-emerald-50 text-sm sm:text-base">
                  {t('op.cash')}
                </div>
                <div className="h-12 rounded-md border flex items-center justify-center font-bold text-teal-600 border-teal-200 bg-teal-50 ring-2 ring-primary ring-offset-1 text-sm sm:text-base">
                  {t('op.pix')}
                </div>
              </div>
              <div className="w-full bg-primary text-primary-foreground h-14 rounded-md flex items-center justify-center font-bold tracking-tight shadow-md cursor-pointer hover:bg-primary/90 transition-colors">
                {t('op.confirm')} <ArrowRight className="h-4 w-4 ml-2" />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
